<template>
  <div class="bill-table-list" v-loading="isLoading">
    <el-row class="flex bill-table-list-btns">
      <div class="flex-item ui-danger">
        <span v-if="showSum">账单总金额：{{ totalMoney }}</span>
      </div>
      <el-button @click="getListDataAll" :loading="isDownLoading" :disabled="!dataList.length"
        >下载列表</el-button
      >
      <el-button
        v-if="!isPayAhead"
        @click="getDetailDataAll"
        :disabled="!dataList.length"
        :loading="isDownLoading"
        >下载明细</el-button
      >
    </el-row>
    <el-table :data="dataList">
      <el-table-column
        v-for="item in listDataMap"
        :key="item.prop"
        :prop="item.prop"
        :label="item.label"
        min-width="140"
      />
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <template v-if="scope.row.serviceTypeName === 'mos费用导入'">-</template>
          <router-link
            v-else
            target="_blank"
            :to="{
              name: '/srm/bill-detail',
              query: {
                id: scope.row.priceId,
                adjustId: scope.row.serviceTypeName === '闭环手工增补' ? scope.row.id : null,
                day: scope.row.day,
                cityCode: scope.row.cityCode,
                sid: scope.row.supplierId,
                actualDay: scope.row.actualDay,
                bizLine: scope.row.businessType,
              },
            }"
            >查看详情
          </router-link>
        </template>
      </el-table-column>
    </el-table>
    <div class="paging-wrapper" v-if="totalPages > 1">
      <el-pagination
        @current-change="handlePageNoChange"
        :current-page.sync="pageNo"
        :page-size="pageSize"
        layout="prev, pager, next, slot, jumper"
        :total="totalAmount"
      >
        <span class="page-indicator"
          ><em>{{ pageNo }}</em
          >/{{ totalPages }}</span
        >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { listDataMap, detailDataMap, detailExtraDataMap } from '@/enums/dataMap_billDataList'
import { export_json_to_excel as exportJsonToExcel } from '@/utils/Export2Excel'
import pagination from '@/mixins/pagination'
import qs from 'qs'

// 列表数据表头
const listDataLabel = []
listDataMap.forEach(item => listDataLabel.push(item.label))

// 详情数据表头
const detailDataLabel = []
const detailAllDataMap = detailExtraDataMap.concat(detailDataMap)
detailAllDataMap.forEach(item => detailDataLabel.push(item.label))

export default {
  mixins: [pagination],

  props: {
    showSum: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      dataList: [],
      dataListAll: [],
      isLoading: false,
      isDownLoading: false,
      params: null,
      listDataMap,
      pageSize: 10,
      isPayAhead: false,
      totalMoney: '-',
    }
  },

  created() {
    this.initPagination('fetchList', false)
  },

  methods: {
    // fetch data list
    fetchList(init = false, params = null, isPayAhead = false) {
      this.isPayAhead = isPayAhead
      if (init) this.pageNo = 1
      this.params = params || this.params
      this.params.pageNo = this.pageNo
      this.params.pageSize = this.pageSize
      const sendParams = this.isPayAhead ? qs.stringify(this.params) : this.params
      // send data
      this.isLoading = true
      this.fetch
        .post(
          this.isPayAhead ? 'srm_settlementPayAheadDataList' : 'srm_settlementDataList',
          sendParams
        )
        .then(res => {
          this.isLoading = false
          const { lists = [], count = 0, sumMoneyByDay = '' } = res.data || {}
          this.totalAmount = count
          this.dataList = lists
          if (this.showSum) {
            // 钱千分位
            const money = sumMoneyByDay.toString().split('.')
            money[0] = money[0].replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
            this.totalMoney = money.join('.')
          }
        })
        .catch(() => {
          this.isLoading = false
        })
    },

    // 下载：查询列表所有数据
    getListDataAll() {
      const params = {
        ...this.params,
      }
      params.pageSize = 100000
      const sendParams = this.isPayAhead ? qs.stringify(params) : params
      this.isDownLoading = true
      this.fetch
        .post(
          this.isPayAhead ? 'srm_settlementPayAheadDataList' : 'srm_settlementDataList',
          sendParams
        )
        .then(res => {
          this.isDownLoading = false
          const { lists = [] } = res.data || {}
          this.downloadListData(lists)
        })
        .catch(() => {
          this.isDownLoading = false
        })
    },

    // 下载列表
    downloadListData(dataList) {
      const defaultTitle = `${this.params.period}-结算账单列表`
      const jsonData = []
      dataList.forEach(dataItem => {
        const itemArr = []
        listDataMap.forEach(item => itemArr.push(dataItem[item.prop]))
        jsonData.push(itemArr)
      })
      exportJsonToExcel(listDataLabel, jsonData, defaultTitle)
    },

    // 下载：查询详情数据
    getDetailDataAll() {
      const params = {
        period: this.params.period,
        cityCode: this.params.cityCode,
        supplierId: this.params.supplierId,
        bizLine: this.params.bizLine,
      }
      this.isDownLoading = true
      this.fetch
        .post('srm_settlementDataExportDailyDetails', params)
        .then(res => {
          this.isDownLoading = false
          this.downloadDetailData(res.data)
        })
        .catch(() => {
          this.isDownLoading = false
        })
    },

    // 下载详情
    downloadDetailData(dataList) {
      const defaultTitle = `${this.params.period}-结算账单详情`
      const jsonData = []
      dataList.forEach(dataItem => {
        const itemArr = []
        detailAllDataMap.forEach(item => itemArr.push(dataItem[item.prop]))
        jsonData.push(itemArr)
      })
      exportJsonToExcel(detailDataLabel, jsonData, defaultTitle)
    },
  },
}
</script>
<style scoped lang="scss">
.bill-table-list-btns {
  margin-bottom: 10px;
}
</style>
